<template>
  <div class="member-invite-record-item">
    <p class="dateTime">{{ displayData.dateTime }}</p>
    <div v-if="displayData.user" class="row">
      <p class="label">{{ $t('member.memberInviteRecord.operator') }}</p>
      <p>{{ displayData.user }}</p>
    </div>

    <div class="row">
      <p class="label">{{ $t('member.memberInviteRecord.memberName') }}</p>
      <p class="value">{{ displayData.username }}</p>
    </div>
    <div class="row">
      <p class="label">{{ $t('member.memberInviteRecord.phoneNumber') }}</p>
      <p class="value">{{ displayData.phone }}</p>
    </div>
    <div class="row">
      <p class="label">{{ $t('member.memberInviteRecord.lineBindingStatus') }}</p>
      <p class="value">{{ displayData.status }}</p>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { get } from 'lodash'
import { t } from '@/plugins/i18n/i18n'
import { formatDate } from '@/utils/date'

export default defineComponent({
  name: 'MemberInviteRecordItem',
  props: {
    record: { type: Object, default: () => ({}) },
  },
  setup (props) {
    const displayData = computed(() => {
      const data = props.record

      const successAt = get(data, 'successAt')

      return {
        id: data.id,
        dateTime: formatDate(get(data, 'updatedAt'), 'YYYY/MM/DD HH:mm'),
        username: get(data, 'Referee.UserInfo.name'),
        phone: get(data, 'Referee.UserInfo.phone'),
        status: successAt ? t('member.memberInviteRecord.bound') : t('member.memberInviteRecord.unbound'),
      }
    })

    return { get, formatDate, displayData }
  },
})
</script>

<style lang="postcss" scoped>
.member-invite-record-item {
  @apply mb-[24px]
}

.row {
    @apply flex gap-[12px] ;
}

.dateTime {
    @apply font-bold text-sub text-gray-60;
}

.row .label {
    @apply font-bold text-base;
    font-size: 14px;
}

.value {
    @apply text-sub text-gray-60;
}
</style>
